export const images = {
    logo: require("../assets/images/logo.png"),
    logo_title: require("../assets/images/logo_title.png"),
    landing_bg: require("../assets/images/Livello 871.svg.png"),
    topbar: require("../assets/images/Top-bar.png"),
    topbar_thin: require("../assets/images/Top-bar-thin.png"),
    not_found: require("../assets/images/not-found.png"),
    not_found_svg: require("../assets/svg/not-found.svg"),
    empty_data: require("../assets/images/empty-data.png"),
    about_img1: require("../assets/images/about-image1.png"),
    about_img2: require("../assets/images/about-image2.png"),
}